import { useState } from "react";

const Select = ({ options, actions, imgs, defaultOption = 0, placeholder }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };
  return (
    <div className={`select-menu ${isDropdownVisible ? "active" : ""}`} onClick={toggleDropdown}>
      <p>
        {defaultOption !== undefined
          ? placeholder === undefined
            ? options[defaultOption]
            : placeholder
          : ""}
      </p>
      <i
        className={`ri-arrow-down-s-line ${isDropdownVisible ? "rotate" : ""}`}
      ></i>
      {isDropdownVisible && (
        <div className="select-dropdown">
          {options.map((option, index) => (
            <div onClick={actions[index]} key={index}>
              {imgs && <img src={imgs[index]} alt="" />}
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Select;
